export default __webpack_public_path__ + "static/media/testimony.201b2205.png";